import PageHeader from "../../components/PageHeader";
import StudentsList from "./StudentsList";
import StudentsHeader from "./StudentHeader";

export default function Students() {

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col md:flex-row justify-between md:items-start  gap-5">
        <PageHeader />
        <div>
          <StudentsHeader />
        </div>
      </div>
      <StudentsList />
    </div>
  );
}
